import {StorageServiceBase} from "./storage-service-base";
import {ILoggerService} from "../logger/logger.service.interface";
import {TimeSpan} from "@sparkware/app-utils";
import {IStorageLock} from "./storage-lock.interface";
import {delay} from "../../../utils/delay";
import {IAcquireTabLockOptions, ILocalStorageService} from "./local-storage-service.interface";

const LOCK_TIMEOUT = TimeSpan.fromSeconds(5);
const LOCK_EXPIRATION_TIME = LOCK_TIMEOUT.add(TimeSpan.fromSeconds(1));
const RANDOM_DELAY_HIGH = TimeSpan.fromSeconds(1);
const RANDOM_DELAY_LOW = TimeSpan.fromMilliseconds(200);



export class LocalStorageService extends StorageServiceBase implements ILocalStorageService {
  constructor(logger: ILoggerService) {
    super(localStorage, logger);
  }


  private async _randomDelay(maxDelay: TimeSpan): Promise<void> {
    await delay(TimeSpan.fromMilliseconds(Math.floor(Math.random() * maxDelay.totalMilliseconds)));
  };


  async acquireTabLock(options: IAcquireTabLockOptions): Promise<IStorageLock> {
    //in order to reduce the chance for 2 tabs to try to acquire the lock in the same moment.
    await this._randomDelay(RANDOM_DELAY_HIGH);

    const timeoutExpiration = Date.now() + LOCK_TIMEOUT.totalMilliseconds;

    do {
      let isAcquired = this._trySetLock(options);
      if(isAcquired) {
        return this._createLockInstance(options, true);
      }

      if(Date.now() >= timeoutExpiration) {
        return this._createLockInstance(options, false);
      } else {
        await this._randomDelay(RANDOM_DELAY_LOW);
      }

    }while (true);
  }


  private _trySetLock(options: IAcquireTabLockOptions): boolean {

    let lockOwnership = this.getJson<IStorageLockOwnership>(options.lockKey.name);
    if(lockOwnership
        && lockOwnership.owner !== options.browserTabId
        && lockOwnership.expirationTime < Date.now()) {
      //the lock ownership belongs to another tab and the lock is not expired
      return false;
    }

    lockOwnership = {
      owner: options.browserTabId,
      expirationTime: Date.now() + LOCK_EXPIRATION_TIME.totalMilliseconds
    };

    this.setJson(options.lockKey.name, lockOwnership);

    lockOwnership = this.getJson<IStorageLockOwnership>(options.lockKey.name);

    return lockOwnership.owner === options.browserTabId;
  }

  private _createLockInstance(options: IAcquireTabLockOptions, isAcquired: boolean): StorageLock {
    return new StorageLock(isAcquired, () => {
      this.removeItem(options.lockKey.name);
    });
  }

}

interface IStorageLockOwnership {
  owner: string;
  expirationTime: number;

}


class StorageLock implements IStorageLock{
  constructor(public readonly isAcquired: boolean,
              private readonly removeLock: () => void) {
  }


  release(): void {
    if(this.isAcquired) {
      this.removeLock();
    }
  }


}